import React from 'react';
import { motion } from 'framer-motion';

const ServiceOutputs = () => {
  const outputs = [
    { title: "Ecommerce Product Pages", desc: "Clean, consistent model imagery that elevates your storefront." },
    { title: "Social Media Campaigns", desc: "Editorial close-ups and lifestyle crops perfect for Instagram." },
    { title: "Paid Advertising", desc: "High-contrast, scroll-stopping visuals designed to convert." },
    { title: "Email Marketing", desc: "Luxurious headers and lookbook-style layouts for newsletters." }
  ];

  return (
    <section className="py-24 bg-ivory border-t border-cream">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          {/* H2 for section */}
          <h2 className="text-4xl md:text-5xl text-espresso mb-6">Comprehensive Output Suite</h2>
          <div className="w-24 h-1 bg-mutedGold mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {outputs.map((item, index) => (
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              key={index}
              className="bg-cream p-8 border border-champagne/30 hover:shadow-premium-hover transition-shadow duration-300"
            >
              <div className="text-mutedGold mb-4 text-2xl">✦</div>
              {/* H3 for each output */}
              <h3 className="font-serif text-xl text-espresso mb-3">{item.title}</h3>
              <p className="text-espresso/70 font-light text-sm leading-relaxed">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceOutputs;